export default __webpack_public_path__ + "media/loudSpeaker.8928c3ca.svg";